module.exports = __webpack_public_path__ + "img/TT.70f3ac43.png";